import { deleteRequest } from '@/core';
import { drivers } from '@/requests';

export default async function deleteDriverRequest(driverId) {
	let url = drivers.getByIdPath(driverId);
	return deleteRequest(url);
}